import { render, staticRenderFns } from "./BetOutcome.vue?vue&type=template&id=55e00f97"
import script from "./BetOutcome.vue?vue&type=script&lang=js"
export * from "./BetOutcome.vue?vue&type=script&lang=js"
import style0 from "./BetOutcome.vue?vue&type=style&index=0&id=55e00f97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports